<template>
  <div class="editaddress">
    <van-nav-bar
      :title="titleText"
      left-text="返回"
      right-text="完成"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <van-cell-group>
      <van-field label="姓名" placeholder="请输入姓名" v-model="name" />
    </van-cell-group>
    <van-cell-group>
      <van-field label="电话" placeholder="请输入电话号码" v-model="phone" />
    </van-cell-group>
    <van-field
      is-link
      readonly
      label="地区"
      placeholder="请选择所在地区"
      v-model="Location"
      @click="show = true"
    />
    <van-popup v-model="show" round position="bottom">
      <van-cascader
        title="请选择所在地区"
        :options="options"
        v-model="cascaderValue"
        @close="show = false"
        @finish="onFinish"
      />
    </van-popup>
    <van-cell-group>
      <van-field label="详细地址" placeholder="请输入详细地址" v-model="detailAddress" />
    </van-cell-group>
  </div>
</template>

<script>
import { getReceivedDetailApi } from '@/api/address'
import { Toast } from 'vant'

export default {
  name: 'EditAddress',
  data () {
    return {
      // 标题：新增地址 / 编辑地址
      titleText: '',
      // 姓名
      name: '',
      // 电话
      phone: '',
      // 详细地址
      detailAddress: '',
      // 选中的地区文字（用于回显）
      Location: '',
      // 是否显示地区选择弹窗
      show: false,
      // 级联选择值
      cascaderValue: '',
      // 选中的省市区对象
      region: {
        province: '',
        city: '',
        region: ''
      },
      // 编辑时的地址 id
      addressId: ''
    }
  },
  computed: {
    // 全国省市区（级联选择数据）
    options () {
      return this.$store.getters['address/nationlAddressList']
    }
  },
  created () {
    this.titleText = this.$route.query.addressId ? '编辑地址' : '新增地址'
    this.addressId = this.$route.query.addressId || ''
    // 首次进入时拉取省市区数据
    if (Object.keys(this.$store.state.address.regionData).length === 0) {
      this.$store.dispatch('address/getAddressSource')
    }
    // 编辑模式：回填地址信息
    if (this.addressId) {
      this.getDetail()
    }
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },
    // 级联选择完成（高德数据中「东莞市 / 中山市 / 嘉峪关市」等城市没有区县层级，此时只到市）
    onFinish ({ selectedOptions }) {
      const opt = (index) => (selectedOptions[index] && selectedOptions[index].text) || ''
      this.region = {
        province: opt(0),
        city: opt(1),
        region: opt(2)
      }
      this.Location = selectedOptions.map(opt => opt.text).join('/')
      this.show = false
    },
    // 编辑模式获取地址详情
    async getDetail () {
      const { data } = await getReceivedDetailApi(this.addressId)
      this.name = data.name
      this.phone = data.phone
      this.detailAddress = data.detail
      this.region = {
        province: data.region.province,
        city: data.region.city,
        region: data.region.region
      }
      this.Location = `${data.region.province}/${data.region.city}/${data.region.region}`
    },
    // 保存
    onClickRight () {
      // 表单校验
      if (!this.name.trim()) {
        Toast('请输入姓名')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        Toast('请输入正确的手机号')
        return
      }
      if (!this.Location) {
        Toast('请选择所在地区')
        return
      }
      if (!this.detailAddress.trim()) {
        Toast('请输入详细地址')
        return
      }
      const obj = {
        name: this.name,
        phone: this.phone,
        region: this.region,
        detail: this.detailAddress
      }
      if (this.addressId) {
        // 编辑
        this.$store.dispatch('address/EditAddress', {
          addressId: this.addressId,
          obj
        })
      } else {
        // 新增
        this.$store.dispatch('address/addAddress', obj)
      }
      // 保存成功返回上一页
      setTimeout(() => {
        this.$router.go(-1)
      }, 600)
    }
  }
}
</script>

<style lang="less" scoped>
.editaddress {
  min-height: 100vh;
  background-color: #f7f7f7;

  .van-cell-group {
    margin-bottom: 10px;
  }
}
</style>
